import agendaApiConfig from "./agendaApiConfig";

const ProfessionalService = {
    async getDetailProfessional(rutPtd) {
        return await agendaApiConfig.get(`/medico/api/medico/${rutPtd}`, {
            baseURL: process.env.REACT_APP_API_BASE
        });
    }
/*     async getDetailProfessional(rutPtd) {
        return await agendaApiConfig.get(`http://localhost:7001/medico/api/medico/${rutPtd}`);
    } */
}

export default ProfessionalService;